import React, { useRef, useState, useEffect, useCallback } from 'react';

// Client logos shown below the hero. To add a new client:
//   1. Run: python3 scripts/process_logo.py <source> frontend/public/clients/<name>.png
//   2. Add an entry here. `href` is optional (omit for a non-linked logo).
const CLIENTS = [
  { name: 'Animax KOT', href: 'https://animaxkot.pl', src: '/clients/animaxkot.png' },
  { name: 'Eco Bedding', href: 'https://ecobedding.pl/', src: '/clients/ecobedding.png' },
  { name: 'Plantimax', href: 'https://plantimax.pl', src: '/clients/plantimax.png' },
  { name: 'RedBlond, Generali Rumia', href: 'https://www.generali-rumia.pl/', src: '/clients/redblond.png' },
  // { name: 'InvoiceLink', href: 'https://invoicelink.pl/', src: '/clients/invoicelink.png' },
];

function Logo({ client }) {
  const img = (
    <img
      src={client.src}
      alt={client.name}
      loading="lazy"
      className="h-9 md:h-12 w-auto object-contain"
      style={{ maxWidth: 190 }}
    />
  );
  const cls = 'client-logo shrink-0 inline-flex items-center justify-center px-6 md:px-10';
  return client.href ? (
    <a href={client.href} target="_blank" rel="noopener noreferrer" aria-label={client.name} className={cls}>
      {img}
    </a>
  ) : (
    <span className={cls}>{img}</span>
  );
}

function LogoSet({ innerRef, ariaHidden }) {
  return (
    <div ref={innerRef} className="flex items-center shrink-0" aria-hidden={ariaHidden || undefined}>
      {CLIENTS.map((c, i) => (
        <Logo key={`${c.name}-${i}`} client={c} />
      ))}
    </div>
  );
}

export default function ClientLogos() {
  const containerRef = useRef(null);
  const setRef = useRef(null);
  const [scroll, setScroll] = useState(false);

  const measure = useCallback(() => {
    const c = containerRef.current;
    const s = setRef.current;
    if (!c || !s) return;
    // Scroll only when a single set is wider than the visible area.
    setScroll(s.scrollWidth > c.clientWidth + 4);
  }, []);

  useEffect(() => {
    measure();
    window.addEventListener('resize', measure);
    // Re-measure once logos have loaded (their width affects the total).
    const imgs = containerRef.current ? containerRef.current.querySelectorAll('img') : [];
    imgs.forEach((img) => {
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  return (
    <section className="bg-[#F6F5F4] py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs md:text-sm text-gray-400 font-semibold uppercase tracking-wider mb-7 md:mb-9">
          Zaufali nam
        </p>
        <div
          ref={containerRef}
          className={scroll ? 'relative overflow-hidden client-marquee' : 'flex justify-center'}
        >
          {scroll ? (
            <div className="flex w-max client-marquee-track">
              <LogoSet innerRef={setRef} />
              <LogoSet ariaHidden />
            </div>
          ) : (
            <LogoSet innerRef={setRef} />
          )}
        </div>
      </div>
    </section>
  );
}
